import React, { useContext } from 'react'
import DispatchContext from '../../DispatchContext';
import { auth } from '../../firebase';

function Logout() {

    const appDispatch = useContext(DispatchContext)

    function logoutHandler() {
        try {
            auth.signOut();
            appDispatch({type: "logout"})
        } catch (error) {
            
        }
        
    }

    return (
        <div className="my-4">
            <button className="btn btn-danger btn-block btn-lg" onClick={logoutHandler}>Logg ut</button>
        </div>
    )

}
export default Logout